import { useMemo } from 'react';
import { isEqualDate, isEmptyRange } from '../utils';

export default function useRangeEndDate(date?: Date, currentRange?: Date[]) {
  return useMemo(
    () =>
      !date || !currentRange
        ? false
        : isEmptyRange(currentRange) || currentRange.length < 2
        ? false
        : isEqualDate(date, currentRange[1]),
    [date, currentRange],
  );
}
